// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formatted--vd_UA{white-space:pre-wrap}", "",{"version":3,"sources":["webpack://./src/gui/Components/DisplayLargeText/index.module.scss"],"names":[],"mappings":"AAAA,kBAAW,oBAAoB","sourcesContent":[".formatted{white-space:pre-wrap}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formatted": "formatted--vd_UA"
};
export default ___CSS_LOADER_EXPORT___;
